const containerWidth = {
  backgroundColor: "white",
  width: "100%",
  maxWidth: "40rem"
}

export default {
  containerWidth
}
